import { render, staticRenderFns } from "./CoursewareManagement.vue?vue&type=template&id=048d3400&scoped=true&"
import script from "./courseware-management.js?vue&type=script&lang=js&"
export * from "./courseware-management.js?vue&type=script&lang=js&"
import style0 from "./CoursewareManagement.vue?vue&type=style&index=0&id=048d3400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048d3400",
  null
  
)

export default component.exports